export const LOW_STOCK_THRESHOLD = 10;
